module.exports = __webpack_public_path__ + "static/media/pic5.36f6743e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pic5.png
// module id = 234
// module chunks = 0